"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.getSpectrumProtoBytes = exports.getSpectrumDefaultClientHeaderFromTsHeader = void 0;
var frame_1 = require("@snapchat/ts-protos/spectrum/streaming/schema/frame");
var common_client_header_1 = require("@snapchat/ts-protos/spectrum/streaming/schema/client/common_client_header");
var headers_1 = require("@snapchat/ts-protos/spectrum/streaming/schema/headers");
var grapheneMetrics_1 = require("../grapheneMetrics");
var logger_1 = require("../logger");
var log = (0, logger_1.getLogger)("spectrumSerialization");
function getSpectrumDefaultClientHeaderFromTsHeader(header, logQueueName, region) {
    return common_client_header_1.DefaultClientHeader.fromPartial({
        sessionId: header.sessionId,
        userGuid: header.userGuid,
        appBuild: header.appBuild,
        appVersion: header.appVersion,
        osType: header.osType,
        clientId: header.clientId,
        locale: header.locale,
        deviceModel: header.deviceModel,
        appStartupType: header.appStartupType,
        webMetadata: header.webMetadata,
        queueName: logQueueName,
        region: region
    });
}
exports.getSpectrumDefaultClientHeaderFromTsHeader = getSpectrumDefaultClientHeaderFromTsHeader;
function getSpectrumProtoBytes(defaultClientHeader, listEventEnvelopes) {
    var headerSequentialItem = getHeaderSequentialItem(defaultClientHeader);
    var listEventSequentialItems = getListSequentialItemsFromEventEnvelopes(listEventEnvelopes);
    var spectrumSequentialItemList = frame_1.SpectrumSequentialItemList.fromPartial({
        spectrumSequentialItems: __spreadArray([headerSequentialItem], __read(listEventSequentialItems), false)
    });
    return frame_1.SpectrumSequentialItemList.encode(spectrumSequentialItemList).finish();
}
exports.getSpectrumProtoBytes = getSpectrumProtoBytes;
function getHeaderSequentialItem(defaultClientHeader) {
    var headerEnvelope = getHeaderEnvelopeFromHeader(defaultClientHeader);
    return frame_1.SpectrumSequentialItem.fromPartial({
        item: {
            $case: "headerEnvelope",
            headerEnvelope: headerEnvelope
        }
    });
}
function getHeaderEnvelopeFromHeader(defaultClientHeader) {
    var clientHeader = getClientHeaderFromDefaultClientHeader(defaultClientHeader);
    var clientHeaderBytes = headers_1.ClientHeader.encode(clientHeader).finish();
    return frame_1.HeaderEnvelope.fromPartial({
        clientHeaderBytes: clientHeaderBytes
    });
}
function getClientHeaderFromDefaultClientHeader(defaultClientHeader) {
    return headers_1.ClientHeader.fromPartial({
        header: {
            $case: "defaultClientHeader",
            defaultClientHeader: defaultClientHeader
        }
    });
}
function getListSequentialItemsFromEventEnvelopes(listEventEnvelopes) {
    return listEventEnvelopes.map(function (eventEnvelope) {
        checkEventEnvelopeFieldValues(eventEnvelope);
        return frame_1.SpectrumSequentialItem.fromPartial({
            item: {
                $case: "eventEnvelope",
                eventEnvelope: eventEnvelope
            }
        });
    });
}
function checkEventEnvelopeFieldValues(eventEnvelope) {
    if (eventEnvelope.clientEpochMs === "0") {
        grapheneMetrics_1.blizzardGraphene.increment({
            metricsName: grapheneMetrics_1.SPECTRUM_CLIENT_TS_ZERO
        });
        log.error("Spectrum event envelope clientEpochMs is 0, which is unexpected.");
    }
    if (eventEnvelope.clientNodepEpochMs === "0") {
        grapheneMetrics_1.blizzardGraphene.increment({
            metricsName: grapheneMetrics_1.SPECTRUM_CLIENT_NODEP_TS_ZERO
        });
        log.error("Spectrum event envelope clientNodepEpochMs is 0, which is unexpected.");
    }
    if (eventEnvelope.sequenceNumber === "0") {
        grapheneMetrics_1.blizzardGraphene.increment({
            metricsName: grapheneMetrics_1.SPECTRUM_SEQUENCE_NUMBER_ZERO
        });
        log.error("Spectrum event envelope sequenceNumber is 0, which is unexpected.");
    }
    if (eventEnvelope.eventBytes.length === 0) {
        grapheneMetrics_1.blizzardGraphene.increment({
            metricsName: grapheneMetrics_1.SPECTRUM_EVENT_BYTES_EMPTY
        });
        log.error("Spectrum event envelope eventBytes length is 0, which is unexpected.");
    }
}
//# sourceMappingURL=spectrumSerialization.js.map